import { Button } from '../../components/ui/Button'
import { Input } from '../../components/ui/Input'
import { hojeIso } from './veiculoUtils'

/** Filtro De/Até livre: dois campos de data, sem presets. */
export function FiltroPeriodo({ de, ate, onChange }: { de: string; ate: string; onChange: (de: string, ate: string) => void }) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="w-40"><Input label="De" type="date" max={ate || hojeIso()} value={de} onChange={(e) => onChange(e.target.value, ate)} /></div>
      <div className="w-40"><Input label="Até" type="date" min={de || undefined} value={ate} onChange={(e) => onChange(de, e.target.value)} /></div>
      {(de || ate) && <Button variant="light" icon="ri-close-line" onClick={() => onChange('', '')}>Limpar</Button>}
    </div>
  )
}
